import React from "react";

import Button from "./base/button";

const ExpandButton = ({
  color,
  isIndication,
  isExpanded,
  setIsExpanded,
  as,
}) => (
  <Button
    as={as || "button"}
    variant="unstyled"
    onClick={isIndication ? () => {} : () => setIsExpanded(!isExpanded)}
    height="fit-content"
    alignSelf={isIndication ? "flex-end" : "center"}
    ml={isIndication ? "-25px" : "10px"}
    mb={isIndication ? "4px" : "unset"}
    style={{
      transition: "transform 0.25s ease-out",
      transform: isExpanded || isIndication ? "rotate(0deg)" : "rotate(180deg)",
    }}
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18.385"
      height="10.607"
      viewBox="0 0 18.385 10.607"
      role="button"
    >
      <g
        id="Group_174"
        data-name="Group 174"
        transform="translate(-247.586 -371.086)"
      >
        <line
          id="Line_6"
          data-name="Line 6"
          x2="11"
          transform="translate(249 372.5) rotate(45)"
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeWidth="2"
        />
        <line
          id="Line_7"
          data-name="Line 7"
          x2="11"
          transform="translate(256.778 380.278) rotate(-45)"
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeWidth="2"
        />
      </g>
    </svg>
  </Button>
);

export default ExpandButton;
